<template lang="html">
  <div class="empty-state-container d-table">
    <router-link
      :to="{ name: 'DiscoverCapsules' }"
      class="empty-state text-center d-table-cell align-middle"
      @mouseenter.native="toggleHover"
      @mouseleave.native="toggleHover"
    >
      <MannequinIcon width="124px" height="124px" :active="hovering" class="mb-4" />
      <h3 class="align-middle primary">No stitched outfits yet...</h3>
      <br />
      <p class="lead secondary">
        Your stitched outfits will appear here for future inspiration.
      </p>
      <p>
        They also help our <b>algorithm</b> learn more about your <b>personal style</b> so we
        <br />
        can curate <b>custom outfits</b> from your <b>wardrobe items</b>.
      </p>
    </router-link>
  </div>
</template>

<script>
import MannequinIcon from "@/components/capsule/icons/Mannequin";

export default {
  components: {
    MannequinIcon,
  },

  data() {
    return {
      hovering: false,
    };
  },

  methods: {
    toggleHover() {
      this.hovering = !this.hovering;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.empty-state-container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-top: 100px;
}

.empty-state {
  font-weight: 300;
  text-decoration: none;
  color: #a9a9a9;

  .primary,
  .secondary {
    font-weight: 300;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/stitchedOutfits/OutfitsEmptyStateContent.vue